function Slick() {
	this.init();
}

Slick.prototype.init = function(target) {
	var self = this;
	$('.events-carousel-slider').each(function() {
		self.createCarousel($(this));
	});
    $('.gallery-slider').each(function() {
        self.createSliderGallery($(this), $(this).closest('.gallery-ps').siblings('.gallery-no-ps').find('.gallery-thumbs-slider'));
    });
    $('.banners-slider').each(function() {
        self.createBannersSlider($(this));
    });
    self.createFieldsStepsSlider($('.fields-steps .step'), $('.fields-steps .step-content-slider'));
    $('.fields-index .fields-container').each(function() {
        self.createFieldsCarousel($(this));
    });

    $('.simple-slider').each(function() {
        self.createSimpleSlider($(this));
    });
};

// Slick.prototype.createAriaDescribeElems = function(slider) {
//     $(slider).each(function() {
//         var slides = $(this).find('.slick-slide');
//         $(slides).each(function() {
//             var $describeElem = $("<span></span>");
//             var title = $(this).find('.title a, p[class*="title"]').first().text();
//             if(!title) {
//                 var $alt = $(this).find('img').attr('alt') ?? '';
//                 title = $alt;
//             }
//             $describeElem.attr({
//                 'hidden': '',
//                 'aria-hidden': 'false',
//                 'id': $(this).attr('aria-describedby'),
//             });
//             title = title.replace(/\u00A0/g, ' ');
//             $describeElem.text(title);
//             $(this).append($describeElem);
//         });
//     });
// }

Slick.prototype.createSimpleSlider = function(slider) {
    var self = this;
    $(slider).slick({
        accessibility: false,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: false,
        infinite: true,
        slidesToShow: 1,
        fade: false,
        swipeToSlide: true,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 737,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                }
            }
        ],
        arrows: false,
        dots: true,
        // nextArrow: $(slider).parent().find('.arrow-right'),
        // prevArrow: $(slider).parent().find('.arrow-left'),
        variableWidth: false,
    });
};

Slick.prototype.createFieldsCarousel = function(slider) {
    var self = this;

    $(slider).slick({
        centerMode: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        swipeToSlide: true,
        fade: false,
        slidesToScroll: 1,
        dots: false,
        nextArrow: $(slider).siblings('.fields-next'),
        prevArrow: $(slider).siblings('.fields-prev'),
        variableWidth: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 737,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                }
            },
        ],
    });

};

Slick.prototype.createFieldsStepsSlider = function(slider1, slider2) {
    var self = this;

    $(slider1).slick({
        centerMode: false,
        infinite: false,
        slidesToShow: 1,
        fade: true,
        swipeToSlide: true,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        // nextArrow: $(slider).parent().find('.arrow-right'),
        // prevArrow: $(slider).parent().find('.arrow-left'),
        variableWidth: false,
        asNavFor: slider2,
    });

    $(slider2).slick({
        centerMode: false,
        infinite: false,
        slidesToShow: 1,
        fade: true,
        swipeToSlide: true,
        slidesToScroll: 1,
        dots: false,
        nextArrow: $(slider2).siblings('.steps-next'),
        prevArrow: $(slider2).siblings('.steps-prev'),
        variableWidth: false,
        asNavFor: slider1,
    });

    $(slider2).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var next = nextSlide+1;
        $('.fields-slide-active li').removeClass('-active');
        $('.fields-slide-active li[data-number="'+next+'"]').addClass('-active');
    });

    $('.fields-slide-active li').on('click', function() {
        var num = parseInt($(this).attr('data-number') - 1);
        $(slider2).slick('slickGoTo', num);
    });
};

Slick.prototype.createCarousel = function(slider) {
	var self = this;

	$(slider).slick({
        centerMode: false,
        infinite: false,
        slidesToShow: 4,
        fade: false,
        swipeToSlide: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 737,
                settings: {
                    slidesToShow: 1,
                }
            }
        ],
        nextArrow: $(slider).parent().find('.arrow-right'),
        prevArrow: $(slider).parent().find('.arrow-left'),
        variableWidth: false,
	});
};

Slick.prototype.createSliderGallery = function(slider1, slider2) {
    $(slider1).slick({
        infinite: true,
        speed: 500,
        arrows: false,
        swipeToSlide: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        initialSlide: 0,
        centerMode: false,
        variableWidth: false,
        asNavFor: slider2
    });
    $(slider2).slick({
        infinite: true,
        speed: 500,
        arrows: true,
        swipeToSlide: true,
        slidesToShow: 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 737,
                settings: {
                    slidesToShow: 3,
                }
            }
        ],
        centerMode: false,
        variableWidth: false,
        nextArrow: $(slider2).siblings('.slick-nav-next'),
        prevArrow: $(slider2).siblings('.slick-nav-prev'),
        asNavFor: slider1
    });

    $(window).load(function() {
        setTimeout(function(){
            $('.gallery-ps').css('display','block');
            $(slider1).slick('setPosition');
        }, 500);
    });

    $(slider2).find('a').on('click', function(e) {
        e.preventDefault();
    });
    $(slider2).find('.gallery-thumb').on('click', function() {
        var slickIndex = $(this).closest('.slick-slide').attr('data-slick-index');
        $(slider2).slick('slickGoTo', slickIndex);
        $(slider1).slick('slickGoTo', slickIndex);
    });

    $('.item-ps').each(function() {
        if ($(this).find('img').attr('data-ytlink') !== "" || $(this).find('img').attr('data-vimeolink') !== "") {
            $(this).find('span.pre-play').addClass('-visible');
        }
    });

    var slideInfo = slider1.parent().find('.slide-info');
    var index = slider1.parent().find('.index');
    var slideCount = slider1.find('.slick-slide:not(.slick-cloned)').length;

    index.text(1);
    slider1.parent().find('.slideCount').text(slideCount);
    slideInfo.text(slider1.find("[data-slick-index='0']").find('.slick-title').text());

    slider1.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var slideText = $(slick.$slides.get(nextSlide)).find('.slick-title').text();
        if (!slideInfo.hasClass('-fade')){
            slideInfo.addClass('-fade');
            setTimeout(function(){
                    slideInfo.removeClass('-fade');
                    slideInfo.text(slideText);
            }, 500);
        }
    });

    slider1.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
        index.text(i);
    });
};

Slick.prototype.handleAdvanceSlideOnVideoEnd = function(event, slick, currentSlide, nextSlide) {
    var currentSlideElement = $(slick.$slides.get(currentSlide));
    var nextSlideElement = $(slick.$slides.get(nextSlide));
    var currentVideo = currentSlideElement.find('video').get(0);
    var nextVideo = nextSlideElement.find('video').get(0);
    if (currentVideo) {
        currentVideo.onended = null;
    }
    if (nextVideo) {
        nextVideo.currentTime = 0;
        nextVideo.play();
        nextVideo.onended = function() {
            $(slick.$slider).slick('slickNext');
        };
    }
};

Slick.prototype.handleInitWithVideoFirstSlide = function(event, slick) {
    var firstSlide = $(slick.$slides.get(0));
    var firstVideo = firstSlide.find('video').get(0);
    if (firstVideo) {
        firstVideo.currentTime = 0;
        firstVideo.play();
        firstVideo.onended = function() {
            $(slick.$slider).slick('slickNext');
        };
    }
};

Slick.prototype.createBannersSlider = function(slider) {
    var self = this;

    if (!$(slider).closest('.banner-wrapper').hasClass('-text-page')) {
        if ($(slider).closest('.content-banner').length) {
           
            $(slider).siblings('a').on('click', function(e) {
                e.preventDefault();
            });

            $(slider).on('beforeChange', self.handleAdvanceSlideOnVideoEnd).on('init', self.handleInitWithVideoFirstSlide).slick({
                centerMode: false,
                slidesToShow: 1,
                fade: true,
                variableWidth: false,
                adaptiveHeight: true,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            adaptiveHeight: false,
                        }
                    }
                ],
                arrows: true,
                nextArrow: $(slider).siblings('.slider-next'),
                prevArrow: $(slider).siblings('.slider-prev'),
                dots: false,
                swipeToSlide: true,
                autoplay: true,
                infinite: true,
                autoplaySpeed: 5000,
                initialSlide: 0,
            });
        } else {
            $(slider).on('beforeChange', self.handleAdvanceSlideOnVideoEnd).on('init', self.handleInitWithVideoFirstSlide).slick({
                centerMode: false,
                slidesToShow: 1,
                fade: true,
                variableWidth: false,
                adaptiveHeight: true,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            adaptiveHeight: false,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            arrows: false,
                        }
                    }
                ],
                arrows: true,
                nextArrow: $(slider).siblings('.banners-slider-next'),
                prevArrow: $(slider).siblings('.banners-slider-prev'),
                dots: true,
                swipeToSlide: true,
                autoplay: true,
                infinite: true,
                autoplaySpeed: 5000,
                initialSlide: 0,
                // pauseOnFocus: true,
                focusOnSelect: true,
            });
        }

        $(slider).each(function() {
            var self = $(this);
            $(this).find('.slick-dots li button').each(function() {
                $(this).text($(this).closest('.banners-slider').find('.banner-item[aria-describedby="'+$(this).parent().attr('id')+'"]').attr('aria-label'));
            });
            $(this).find('.slick-dots li button').on('keypress', function(e){
                if (e.key === 'Enter' || e.key === 'Space') {
                    self.on('afterChange', function(event, slick, currentSlide) {
                        self.find('.slick-slide[aria-hidden="false"]').focus();
                        self.off('afterChange'); 
                    });
                }
            });
        });
    }
};